// FieldShowAccessField.jsx

import React from 'react';

// Components
import Checkbox from 'components/checkbox/Checkbox';
import ModalField from 'components/modal/field/ModalField';
import ModalHint from 'components/modal/hint/ModalHint';
import ModalLabel from 'components/modal/label/ModalLabel';

/**
 * FieldShowAccessField
 *
 * Toggle for People fields that act as rosters (e.g. Project Team):
 * show Access / No Access per selected person in dynamic forms.
 *
 * @returns {ReactNode} The rendered control.
 */
const FieldShowAccessField = ({
  showAccess,
  onShowAccessChange,
}) => (

  <ModalField>

    <ModalLabel label="Access" />
    <ModalHint hint="When enabled, each selected person can be marked Access or No Access on this record (roster-style fields such as Project Team)." />

    <Checkbox
      value={showAccess === true}
      size="22"
      label="Show access setting"
      onChange={() => onShowAccessChange(!(showAccess === true))}
    />

  </ModalField>

);

// Dev Tools
FieldShowAccessField.displayName = 'FieldShowAccessField';

export default FieldShowAccessField;
